import { Router } from '@angular/router';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { UtilsService } from '../../../core/services/utils.service';
import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SignUpComponent } from '../sign-up/sign-up.component';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AuthService } from '../../../core/services/auth.service';
import { Login, Changepassword } from 'src/app/core/interface/auth.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { REGEX_PATTERNS } from 'src/app/core/constants/regex-patterns.constant';
import { SuccessMessageComponent } from '../../all-modals/success-message/success-message.component';
import { ErrorMessageComponent } from '../../all-modals/error-message/error-message.component';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-reset-password.component.html',
  styleUrls: ['./forgot-reset-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  type: any = '';
  forgotPasswordForm: FormGroup;
  resetPasswordForm: FormGroup;

  forgotPasswordSubmitted = false;
  resetPasswordSubmitted = false;
  isError: boolean = false;
  isSuccess: boolean = false;
  password = 'password';
  cpassword = 'password';

  userEmail: '';
  @Input() public modalType;
  @Input() public reset_token;
  @Input() public paramID;

  errorMessage: any;
  isValid: any = false;

  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private utils: UtilsService,
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private route: Router
  ) { }

  ngOnInit() {

    this.forgotPasswordForm = this.formBuilder.group({
      email: [null, Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.EMAIL_PATTERN)])],
    });

    this.resetPasswordForm = this.formBuilder.group({
      password: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.pattern(REGEX_PATTERNS.PASSWORD_PATTERN), this.noWhitespaceValidator])],
      password_confirmation: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.pattern(REGEX_PATTERNS.PASSWORD_PATTERN), this.noWhitespaceValidator])],
    }, {
      validator: this.utils.mustMatch('password', 'password_confirmation')
    });

    if (this.paramID) {
      this.verifyResetToken();
    }
    else {
      this.type = this.modalType;
    }
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  closeDialog() {
    this.activeModal.close();
  }

  onSubmit() {
    this.errorMessage = '';
    this.forgotPasswordSubmitted = true;

    if (this.forgotPasswordForm.invalid) {
      return;
    }

    const params: Login = {
      'user': { ...this.forgotPasswordForm.value }
    };
    this.userEmail = this.forgotPasswordForm.value.email;

    this.spinner.show();
    this.authService.forgotPassword(params).subscribe(
      (response: any) => {
        if (response.success) {
          this.spinner.hide();
          this.forgotPasswordSubmitted = false;
          this.isSuccess = true;
          this.isError = false;
          this.forgotPasswordForm.reset();
        } else {
          this.spinner.hide();
          this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.EMAIL_NOT_REGISTERED;
          this.isError = true;
        }

      }, (error: any) => {
        this.spinner.hide();
        // this.errorMessage = 'User not available';
        this.isError = true;
      });
  }

  onResetPassword() {
    this.resetPasswordSubmitted = true;
    if (this.resetPasswordForm.invalid) {
      return;
    }

    this.resetPasswordForm.value
    const params: Changepassword = {
      'user': { ...this.resetPasswordForm.value }
    };
    params.user.reset_password_token = this.reset_token;
    params.user.password = this.utils.encode(params.user.password);
    params.user.password_confirmation = this.utils.encode(params.user.password_confirmation);

    this.authService.resetPassword(params).subscribe(
      (response: any) => {
        if (response.success) {
          this.closeDialog();
          const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modalRef.componentInstance.message = 'Password reset Successfully.\n Please login to continue.';
          // this.toastr.success('Password reset Successfully.\n Please login to continue.');

        }
        else {
          this.isError = true;

        }
      }, (error: any) => {
        this.spinner.hide();
        this.isError = true;
        this.resetPasswordForm.reset();
        this.resetPasswordSubmitted = false;
      });
  }

  openSignupModal() {
    this.closeDialog();
    const modalRef = this.modalService.open(SignUpComponent, { size: 'lg', centered: true });
  }

  verifyResetToken() {
    this.authService.checkResetToken(this.reset_token, this.paramID).subscribe(
      (response: any) => {
        if (response.success) {
          this.isValid = response.data.user.is_valid;
          if (this.isValid) {
            this.type = this.modalType;
          }
          else {
            this.closeDialog();
            this.route.navigate(['/']);
            const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
            modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.USER_ALREADY_RESET_PASSWORD;
            modalRef.componentInstance.forModal = 'reset-fail';
          }
        }
        else {
          // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
        }
      }, (error: any) => {
        // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
      })
  }

  togglePassword() {
    if (this.password == 'text') {
      this.password = 'password';
    } else {
      this.password = 'text';
    }
  }

  toggleCPassword() {
    if (this.cpassword == 'text') {
      this.cpassword = 'password';
    } else {
      this.cpassword = 'text';
    }
  }
}
